import React from "react";

const SimpleInputTextField = ({
  label,
  value,
  onChange,
  maxLength = 50,
  placeHolder,
  wrapperClassName,
  defaultValue,
  isReadOnly = false,
  isDisabled = false,
  isTextArea = false,
  isSmall = false,
}) => {
  return (
    <div>
      {label && <label className="field-label">{label}</label>}
      <div
        className={`input-field-wrapper ${
          wrapperClassName && wrapperClassName
        }`}
      >
        {isTextArea ? (
          <textarea
            value={value}
            onChange={onChange}
            disabled={isDisabled}
            maxLength={maxLength}
            readOnly={isReadOnly}
            placeholder={placeHolder}
            defaultValue={defaultValue}
            className="input-textarea"
            style={{ height: "100%", width: "100%", resize: "none" }}
          />
        ) : (
          <input
            type="text"
            value={value}
            onChange={onChange}
            disabled={isDisabled}
            maxLength={maxLength}
            readOnly={isReadOnly}
            className={
              isSmall
                ? "input-textfield-small input-textfield-without-icon"
                : "input-textfield input-textfield-without-icon"
            }
            placeholder={placeHolder}
            defaultValue={defaultValue}
          />
        )}
      </div>
    </div>
  );
};

export default SimpleInputTextField;
